var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLkLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8611_329047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 92.262L20.3983 80.4523L8.5 68.6406C13.4722 75.7168 13.4722 85.1859 8.5 92.262Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2422 56.2323L33.1405 68.0421L21.2422 79.8519C26.2144 72.7757 26.2144 63.3066 21.2422 56.2305V56.2323Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 43.8252L20.3983 55.635L8.5 67.4466C13.4722 60.3686 13.4722 50.9013 8.5 43.8252Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.019 113.048L103.152 107.253L101.086 109.494V113.048H98.291V99.5605H101.086V105.983C101.086 105.983 102.099 104.936 106.618 99.5605H110.255L105.087 105.164L110.466 113.048H107.021H107.019Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.443 108.85C113.633 110.219 114.515 110.96 115.872 110.96C116.696 110.96 117.48 110.598 117.806 109.877H120.542C119.949 111.891 118.11 113.278 115.795 113.278C112.83 113.278 110.742 111.111 110.742 108.053C110.742 104.996 112.809 102.866 115.776 102.866C118.744 102.866 120.752 105.108 120.752 108.053C120.752 108.49 120.715 108.852 120.715 108.852H113.441L113.443 108.85ZM113.48 106.911H118.037C117.845 105.791 117.021 105.031 115.76 105.031C114.498 105.031 113.71 105.772 113.48 106.911Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.898 112.876L120.936 103.092H123.826L126.239 109.742L128.67 103.092H131.502L125.895 117H123.215L124.9 112.876H124.898Z",
    fill: "#70C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.207 91.4301V43.8252H54.2864V91.4301H45.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6465 48.4578C61.6465 45.2847 63.9483 43 67.1471 43C70.346 43 72.6459 45.2847 72.6459 48.4578C72.6459 51.631 70.3441 53.8541 67.1471 53.8541C63.9502 53.8541 61.6465 51.631 61.6465 48.4578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6868 58.1699H62.6074V91.4303H71.6868V58.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5518 58.1697V65.2794H90.3728V91.4319H81.2915V65.2775H76.4961V58.1678H81.2915V55.5042C81.2915 47.506 85.8951 43.8232 92.6746 43.8232C94.273 43.8232 95.3619 43.9502 95.3619 43.9502V51.6946C95.3619 51.6946 94.9764 51.6292 93.9533 51.6292C91.7794 51.6292 90.3728 52.5177 90.3728 55.312V58.1678H95.5518V58.1697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.072 77.4028C107.713 81.9721 110.654 84.4472 115.194 84.4472C117.944 84.4472 120.565 83.2395 121.654 80.8298H130.797C128.815 87.5588 122.677 92.1916 114.938 92.1916C105.024 92.1916 98.0547 84.9568 98.0547 74.7354C98.0547 64.5141 104.962 57.4062 114.874 57.4062C124.787 57.4062 131.5 64.8986 131.5 74.7354C131.5 76.1951 131.373 77.4028 131.373 77.4028H107.072ZM107.2 70.9277H122.419C121.782 67.1833 119.032 64.6448 114.809 64.6448C110.585 64.6448 107.967 67.1199 107.198 70.9277H107.2Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8611_329047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 74,
    fill: "white",
    transform: "translate(8.5 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLkLogin);
export default __webpack_public_path__ + "static/media/Logo_LK_login.a658c31392aeddd7f6a796677c065615.svg";
export { ForwardRef as ReactComponent };